import dashboard from "@/acl/permissions/dashboard";
import dexpara from "@/acl/permissions/dexpara";
import loincs from "@/acl/permissions/loincs";
import {
    rnds_company_edit,
    rnds_create,
    rnds_index,
    rnds_show
} from "@/acl/permissions/rnds";
import {    
    interopera_create
} from "@/acl/permissions/interopera";
import core from '@/acl/permissions/core';
import triggers from "@/acl/permissions/triggers";
import tuevs_components from "@/acl/permissions/tuevs/components";
import tuevs_exams from "@/acl/permissions/tuevs/exams";
import tuevs_materials from "@/acl/permissions/tuevs/materials";
import tuevs_complements from "@/acl/permissions/tuevs/complements";
import tuevs_methods from "@/acl/permissions/tuevs/methods";
import tuevs_scales from "@/acl/permissions/tuevs/scales";
import tuevs_times from "@/acl/permissions/tuevs/times";
import tuevs_exam_results from "@/acl/permissions/tuevs/exam_results";
import vns from '@/acl/permissions/vns/vns';
import vns_attributes from '@/acl/permissions/vns/attributes';
import vns_credentials from "@/acl/permissions/vns/credentials";
import vns_fileformats from '@/acl/permissions/vns/fileformats';
import vns_functions from "@/acl/permissions/functions";
import vns_integrations from '@/acl/permissions/vns/integrations';
import vns_integrationhelper from '@/acl/permissions/vns/integrationhelper';
import vns_manufactures from '@/acl/permissions/vns/manufactures';
import vns_permissions from '@/acl/permissions/vns/vns_permissions';
import vns_protocols from '@/acl/permissions/vns/protocols';
import vns_protocols_settings from '@/acl/permissions/vns/protocolSettings';
import vns_ranges from '@/acl/permissions/vns/ranges';
import vns_states from '@/acl/permissions/vns/states';
import vns_report_trash from "@/acl/permissions/vns/reportTrash";
import vns_report_control from "@/acl/permissions/vns/reportControl";
import vns_report_editable from "@/acl/permissions/vns/reportEditable";
import vns_monitors, {
    vns_monitor_tipo,
    vns_monitor_tipo_info,
    vns_monitor_tipo_latency,
    vns_monitor_tipo_location,
    vns_monitor_tipo_temperature,
    vns_monitor_observation,
    vns_monitor_observation_support,
    vns_monitor_observation_lis,
    vns_monitor_tipo_jira,
} from '@/acl/permissions/vns/vns_monitors';
import container_support from '@/acl/permissions/container_support';
import review_observation from '@/acl/permissions/review_observation';
import audit from '@/acl/permissions/audit';

const tuevs_complete_crud = tuevs_exams.concat(
    tuevs_components,
    tuevs_complements,
    tuevs_materials,
    tuevs_methods,
    tuevs_scales,
    tuevs_times,
    tuevs_exam_results
)

const vns_complete_crud = vns.concat(
    vns_attributes,
    vns_credentials,
    vns_fileformats,
    vns_functions,
    vns_integrations,
    vns_integrationhelper,
    vns_manufactures,
    vns_permissions,
    vns_protocols,
    vns_protocols_settings,
    vns_ranges,
    vns_states,
    vns_report_trash,
    vns_report_control,
    vns_report_editable
)

const rnds_transmission = [
    ...rnds_index,
    ...rnds_create,
    ...rnds_show
]

const interopera_transmission = [
    ...interopera_create
]

const admin = vns_complete_crud.concat(
    dashboard,
    dexpara,
    loincs,
    core,
    rnds_transmission,
    interopera_transmission,
    triggers,
    tuevs_complete_crud,
    vns_monitors,
    container_support,
    audit,
    review_observation
)

const vns_exam_monitors = [
    ...vns_monitor_observation,
    ...vns_monitor_observation_support,
    ...vns_monitor_observation_lis
]

const vns_monitor_tipo_complete = [
    ...vns_monitor_tipo,
    ...vns_monitor_tipo_info,
    ...vns_monitor_tipo_latency,
    ...vns_monitor_tipo_temperature,
    ...vns_monitor_tipo_location,
    ...vns_monitor_tipo_jira,
]

const vns_monitor_tipo_drive = [
    ...vns_monitor_tipo,
    ...vns_monitor_tipo_temperature,
    ...vns_monitor_tipo_location
]

const vns_monitor_tipo_cliente = [
    ...vns_monitor_tipo,
    ...vns_monitor_tipo_info,
    ...vns_monitor_tipo_latency,
    ...vns_monitor_tipo_location,
]

export default {
    admin,
    dashboard,
    dexpara,
    loincs,
    rnds_transmission,
    interopera_transmission,
    core,
    triggers,
    tuevs_complete_crud,
    vns_complete_crud,
    vns_exam_monitors,
    vns_monitor_tipo_complete,
    vns_monitor_tipo_drive,
    container_support,
    vns_monitor_tipo_cliente,
    review_observation
}